var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLittleDocIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.75C0 1.50736 1.00736 0.5 2.25 0.5H7.6287C8.2254 0.5 8.79772 0.737053 9.21968 1.15901L11.341 3.28033C11.7629 3.70229 12 4.27459 12 4.87132V13.25C12 14.4927 10.9927 15.5 9.75 15.5H2.25C1.00736 15.5 0 14.4927 0 13.25V2.75ZM2.25 2C1.83579 2 1.5 2.33579 1.5 2.75V13.25C1.5 13.6642 1.83579 14 2.25 14H9.75C10.1642 14 10.5 13.6642 10.5 13.25V4.87132C10.5 4.67241 10.4209 4.48164 10.2803 4.34099L8.15903 2.21967C8.01832 2.07902 7.8276 2 7.6287 2H2.25ZM3 6.5C3 6.08579 3.33579 5.75 3.75 5.75H8.25C8.66422 5.75 9 6.08579 9 6.5C9 6.91423 8.66422 7.25 8.25 7.25H3.75C3.33579 7.25 3 6.91423 3 6.5ZM3 9.5C3 9.08578 3.33579 8.75 3.75 8.75H6.75C7.16423 8.75 7.5 9.08578 7.5 9.5C7.5 9.91422 7.16423 10.25 6.75 10.25H3.75C3.33579 10.25 3 9.91422 3 9.5Z",
    fill: "#0D0D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLittleDocIcon);
export default __webpack_public_path__ + "static/media/littleDocIcon.dde2b05388104f39410a162130906007.svg";
export { ForwardRef as ReactComponent };